import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { PlusIcon } from '@/components/icons/plus-iocn';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import { useEditTargetsContext } from '@/contexts/edit-targets-context';

import { Form } from './form';

export function EditTargetsContent() {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const { hiringGoal, hiringGoalUrl } = useEditTargetsContext();

  const onFormChange = (enabled: boolean) => {
    setIsFormDirty(enabled);
  };

  const showSpinner = (isSaving: boolean) => {
    setIsSaving(isSaving);
  };

  if (!hiringGoal) return null;

  const { is_current: isCurrent } = hiringGoal;

  return (
    <>
      <Form
        onFormChange={onFormChange}
        hiringGoal={hiringGoal}
        showSpinner={showSpinner}
      >
        <DialogFooter>
          {isCurrent ? (
            <Button
              type="submit"
              disabled={!isFormDirty || isSaving}
              className="w-19"
            >
              {isSaving && <Loader2 className="animate-spin" />}
              <FormattedMessage defaultMessage="Save" />
            </Button>
          ) : (
            <Button>
              <PlusIcon />
              <Link to={String(hiringGoalUrl)} target="_blank">
                <FormattedMessage defaultMessage="Add Hiring Goal" />
              </Link>
            </Button>
          )}
        </DialogFooter>
      </Form>
    </>
  );
}
